import { useQuery } from "react-query";
import { useProjectPermission } from "~/components/project/useProjectPermission";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useProjectsForPeopleInvitation = () => {
  const { canUserManageProject } = useProjectPermission();
  return useQuery({
    queryKey: "projects",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects`,
        signal,
      }),
    select: (projects) => {
      return projects.filter((p) => canUserManageProject(p));
    },
  });
};
